import { getApiBasePath } from "@/app/base-path";
import { SCHEDULE_ERROR_STATUS } from "@/lib/utils/schedule-error-response";

export async function scheduleAppointment(params: Record<string, unknown>): Promise<any> {
  const response = await fetch(`${getApiBasePath()}/api/schedule-appointment/`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(params),
  });

  let responseBody: unknown;

  try {
    responseBody = await response.json();
  } catch {
    throw new Error(`Invalid JSON response: ${response.status}`);
  }

  if (response.ok || response.status === SCHEDULE_ERROR_STATUS) return responseBody;

  throw new Error(`Unexpected response status: ${response.status}`);
}
